module.exports = __webpack_public_path__ + "images/hubertus.png?29c1094db75a7a5a567a6f1867e1b6db";